import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {IDriverType} from 'app/blocks/model/driver-type.model';
import {IResourcePlanningFilter} from 'app/blocks/model/resource-planning-filter/resource-planning-filter.model';

export interface IUserEntity extends IBaseEntity {
    id?: any;
    login?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    activated?: boolean;
    langKey?: string;
    authorities?: any[];
    isMfaEnabled?: boolean;
    mfaKey?: boolean;
    roles?: any;
    trafficAreaId?: any;
    excludedDriverTypes?: IDriverType[];
    resourceFilters?: IResourcePlanningFilter[];
}

export class UserEntity extends BaseEntity implements IUserEntity {
    public id?: any;
    public login?: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public activated?: boolean;
    public langKey?: string;
    public authorities?: any[];
    public isMfaEnabled?: boolean;
    public mfaKey?: boolean;
    public roles?: any;
    public trafficAreaId?: any;
    public excludedDriverTypes?: IDriverType[] = [];
    public resourceFilters?: IResourcePlanningFilter[] = [];

    constructor(user?: any) {
        super();
        if (user) {
            this.id = user.id;
            this.login = user.login;
            this.firstName = user.firstName;
            this.lastName = user.lastName;
            this.email = user.email;
            this.activated = user.activated;
            this.langKey = user.langKey;
            this.authorities = user.authorities;
            this.isMfaEnabled = user.isMfaEnabled;
            this.mfaKey = user.mfaKey;
            this.roles = user.roles;
            this.trafficAreaId = user.trafficAreaId;
            this.excludedDriverTypes = user.excludedDriverTypes;
            this.resourceFilters = user.resourceFilters || [];
        } else {
            this.excludedDriverTypes = [];
            this.resourceFilters = [];
        }
    }

    clone(): IBaseEntity {
        return new UserEntity(this);
    }
}
